<template>
<nav class="bg-white fixed w-full top-0 z-20">
  <div class="flex flex-wrap items-center justify-between mx-auto px-4 py-2">
    <a href="https://loveandletters.uk" class="flex items-center space-x-3 rtl:space-x-reverse">
        <img src="@/assets/logos/love_and_letters_rectangle_logo_colour.svg" class="h-16 md:h-20" alt="Love and Letters Logo" />
    </a>
    <button
        @click="toggleMenu"
        type="button"
        class="flex flex-col justify-center items-center w-12 h-12 md:hidden focus:outline-none z-50"
        aria-controls="navbar-default"
        :aria-expanded="isMenuOpen ? 'true' : 'false'"
      >
        <span class="sr-only">Toggle menu</span>
        <!-- Top Line -->
       <span
  :class="`block transition-all duration-300 ease-out h-0.5 w-8 rounded-sm ${
    isMenuOpen ? 'bg-white rotate-45 translate-y-2' : 'bg-pink-900 -translate-y-0.5'
  }`"
></span>
<!-- Middle Line -->
<span
  :class="`block transition-all duration-300 ease-out h-0.5 w-8 rounded-sm my-1.5 ${
    isMenuOpen ? 'opacity-0' : 'bg-pink-900 opacity-100'
  }`"
></span>
<!-- Bottom Line -->
<span
  :class="`block transition-all duration-300 ease-out h-0.5 w-8 rounded-sm ${
    isMenuOpen ? 'bg-white -rotate-45 -translate-y-2' : 'bg-pink-900 translate-y-0.5'
  }`"
></span>
      </button>
     <div
        :class="[
          'fixed top-0 left-0 w-full bg-black bg-opacity-70 transition-all duration-500',
          isMenuOpen ? 'h-full' : 'h-0 overflow-hidden', /* Ensure it hides when closed */
        ]"
        id="navbar-default"
      >
        <!-- Menu items centered vertically -->
        <ul
          class="font-medium flex flex-col items-center justify-center h-full text-white space-y-10 transition-all duration-300 ease-out font-serif"
          :class="isMenuOpen ? 'block' : 'hidden'"  
        >
          <li><a href="#services" class="block py-2 px-3 text-4xl">Services</a></li>
          <li><a href="#process" class="block py-2 px-3 text-4xl">How It Works</a></li>
          <li><a href="#testimonials" class="block py-2 px-3 text-4xl">Reviews</a></li>
          <li><a href="#about" class="block py-2 px-3 text-4xl ">About</a></li>
          <li><a href="#gallery" class="block py-2 px-3 text-4xl ">Gallery</a></li>
          <li><a href="#contact" class="block py-2 px-3 text-4xl ">Contact</a></li>
        </ul>
      </div>
<div class="hidden md:flex items-center space-x-14 pr-8 text-pink-900 font-medium">
        <a href="#services" class="lg:text-xl sm:text-lg" >Services</a>
        <a href="#process" class="lg:text-xl sm:text-lg" >How It Works</a>
        <a href="#testimonials" class="lg:text-xl sm:text-lg">Reviews</a>
        <a href="#about" class="lg:text-xl sm:text-lg">About</a>
        <a href="#gallery" class="lg:text-xl sm:text-lg">Gallery</a>
        <a href="#contact" class="lg:text-xl sm:text-lg">Contact</a>
      </div>
  </div>
</nav>

</template>


<script>
export default {
  name: 'NavBar',
  data() {
    return {
      isMenuOpen: false, // Track whether the menu is open or closed
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen; // Toggle menu open state
    },
  }, 
};
</script>

<style scoped>
.line {
  width: 24px;
  height: 2px;
  background-color: #333; /* Set your preferred color */
  transition: all 0.3s ease; /* Smooth transition for the morphing effect */
  margin: 5px 0; /* Adjust margin for spacing */
}

.rotate-top {
  transform: translateY(8px) rotate(45deg); /* Slightly increased translation */
}

.rotate-bottom {
  transform: translateY(-8px) rotate(-45deg); /* Slightly increased translation */
}

.fade-out {
  opacity: 0;
}

ul {
  transition: transform 0.5s ease-in-out; /* Smoothly animate items */
}

</style>